import { render, staticRenderFns } from "./trainingReportHome.vue?vue&type=template&id=2c4e76e4&scoped=true&"
import script from "./trainingReportHome.vue?vue&type=script&lang=js&"
export * from "./trainingReportHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e76e4",
  null
  
)

export default component.exports